import Examination_navbar from "./Examination_navbar";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { NavLink, Link } from "react-router-dom";
import ExamsDropDown from "../Shared/ExamsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import { Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SessionsDropDown from "../Shared/SessionsDropDown";
import SubjectDropDown from "../Shared/SubjectDropDown";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import SectionDropDown from "../Shared/SectionDropDown";
import Pagination from "../General/Pagination";

const ManageClassSubjects = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [section, setSection] = useState({});
  const [Total_Marks, setTotal_Marks] = useState("");
  const [Pass_Marks, setPass_Marks] = useState("");
  const [Subject_ID, setSubject_ID] = useState("");

  const [validatedSection, setValidatedSection] = useState(false);

  const [ExamID, setExamID] = useState("");
  const [validatedSubject, setValidatedSubject] = useState(false);
  const [loadingSubjects, setLoadingSubjects] = useState(false);
  const [loadingsubjectButton, setLoadingSubjectButton] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState({});
  const [loadingUpdatesubjectButton, setLoadingUpdatesubjectButton] =
    useState(false);
  const [validatedSubjectUpdate, setValidatedSubjectUpdate] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [hasSearched, setHasSearched] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);

  const [show, setShow] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [WingId, setWingId] = useState("0");
  const [SessionId, setSessionId] = useState(
    localStorage.getItem("DefaultSession") || "0"
  );
  const [ClassId, setClassId] = useState("");
  const [SectionID, setSectionID] = useState("0");

  const [subjects, setSubjects] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [addEmployeeId, setAddEmployeeId] = useState(null);
  const [editEmployeeId, setEditEmployeeId] = useState(null);
  const [editSubjectId, setEditSubjectId] = useState("");
  const [editTotalMarks, setEditTotalMarks] = useState("");
  const [editPassMarks, setEditPassMarks] = useState("");

  const sectionIdNum = parseInt(SectionID, 10) || 0;
  const examIdNum = parseInt(ExamID, 10) || 0;

  const examSessionId = useMemo(() => {
    const fromSection =
      section?.SelectedClass?.Session_ID ||
      section?.SelectedClass?.Selected_Session?.Session_ID;
    if (fromSection) return parseInt(fromSection, 10);
    return parseInt(SessionId, 10) || 0;
  }, [section, SessionId]);

  const dropdownOptions = useMemo(
    () =>
      employees.map((item) => ({
        value: item.ID,
        label: `${item.Name} (${item.Code})`,
        code: String(item.Code || ""),
        name: String(item.Name || ""),
      })),
    [employees]
  );

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      minHeight: "38px",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const filterTeacherOption = (option, inputValue) => {
    const term = (inputValue || "").trim().toLowerCase();
    if (!term) return true;
    const label = (option.label || "").toLowerCase();
    const code = (option.data?.code || "").toLowerCase();
    const name = (option.data?.name || "").toLowerCase();
    return (
      label.includes(term) || code.includes(term) || name.includes(term)
    );
  };

  const teacherSelectCommonProps = {
    className: "react-select-container",
    classNamePrefix: "react-select",
    isSearchable: true,
    isClearable: true,
    filterOption: filterTeacherOption,
    menuPortalTarget: document.body,
    menuPosition: "fixed",
    styles: customStyles,
    placeholder: "Search teacher by name or code...",
    noOptionsMessage: () => "No teacher found",
  };

  const bumpList = () => setRefreshCounter((c) => c + 1);

  const fetchSubjects = useCallback(() => {
    if (!hasSearched || sectionIdNum <= 0 || examIdNum <= 0) {
      return;
    }

    setLoadingSubjects(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      Section_Id: sectionIdNum,
      ExamID: examIdNum,
    };

    axios({
      method: "post",
      url: config.base_url + "Sections/GetSectionSubjects",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setSubjects(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setSubjects([]);
          setTotalRecords(0);
          if (response.data.status_message) {
            toast.info(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
        setLoadingSubjects(false);
      })
      .catch(function () {
        setSubjects([]);
        setTotalRecords(0);
        setLoadingSubjects(false);
        toast.error("Unable to load section subjects.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [
    AccessKey,
    UserID,
    MemberType,
    hasSearched,
    sectionIdNum,
    examIdNum,
    pageNo,
    pageSize,
    refreshCounter,
  ]);

  useEffect(() => {
    document.title = "Manage Section Level Subjects";
    fetchSubjects();
  }, [fetchSubjects]);

  useEffect(() => {
    if (sectionIdNum <= 0) {
      setSection({});
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "Sections/GetSectionByID",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        ID: sectionIdNum,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setSection(response.data.Section || {});
        } else {
          setSection({});
        }
      })
      .catch(function () {
        setSection({});
      });
  }, [sectionIdNum, AccessKey, UserID, MemberType]);

  useEffect(() => {
    axios({
      method: "post",
      url: config.base_url + "Payroll/SearchEmployees",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        Is_Resigned: false,
        UserID: UserID,
        MemberType: MemberType,
        SchoolID: 1,
        pageNo: 1,
        pageSize: 10000,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setEmployees(response.data.ListofRecords || []);
        } else {
          setEmployees([]);
        }
      })
      .catch(function () {
        setEmployees([]);
      });
  }, [AccessKey, UserID, MemberType]);

  const handleClose = () => {
    setShow(false);
    setSelectedSubject({});
    setEditEmployeeId(null);
    setEditSubjectId("");
    setEditTotalMarks("");
    setEditPassMarks("");
  };

  const handleShow = (item) => {
    setSelectedSubject(item);
    setEditSubjectId(String(item.Subject_ID || ""));
    setEditTotalMarks(String(item.Total_Marks ?? ""));
    setEditPassMarks(String(item.Pass_Marks ?? ""));
    setEditEmployeeId(item.Teacher_ID || null);
    setShow(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidatedSection(true);
      return;
    }

    if (sectionIdNum <= 0 || examIdNum <= 0) {
      toast.warning("Please select section and examination.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setValidatedSection(true);
      return;
    }

    setPageNo(1);
    setHasSearched(true);
    bumpList();
    setValidatedSection(true);
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value, 10) || 10);
    setPageNo(1);
  };

  const validateMarks = (total, pass) => {
    const totalNum = Number(total);
    const passNum = Number(pass);
    if (!Number.isFinite(totalNum) || !Number.isFinite(passNum)) {
      return false;
    }
    if (totalNum <= 0 || passNum < 0) {
      return false;
    }
    return totalNum >= passNum;
  };

  const resetAddForm = () => {
    setSubject_ID("");
    setTotal_Marks("");
    setPass_Marks("");
    setAddEmployeeId(null);
    setValidatedSubject(false);
  };

  const handleUpdateSubject = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidatedSubjectUpdate(true);
      return;
    }

    if (!validateMarks(editTotalMarks, editPassMarks)) {
      toast.error("Total marks must be greater than or equal to pass marks.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (!editEmployeeId) {
      toast.warning("Please select a teacher.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setLoadingUpdatesubjectButton(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      MemberType: MemberType,
      ID: selectedSubject.ID,
      SectionID: sectionIdNum,
      Subject_ID: parseInt(editSubjectId, 10),
      Teacher_ID: editEmployeeId,
      Exam_ID: examIdNum,
      Total_Marks: parseInt(editTotalMarks, 10),
      Pass_Marks: parseInt(editPassMarks, 10),
    };

    axios({
      method: "post",
      url: config.base_url + "Sections/UpdateSectionSubject",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          bumpList();
          handleClose();
        } else {
          toast.error(
            response.data.status_message || "Unable to update subject.",
            { position: toast.POSITION.TOP_RIGHT }
          );
        }
        setLoadingUpdatesubjectButton(false);
      })
      .catch(function () {
        setLoadingUpdatesubjectButton(false);
        toast.error("Network error. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });

    setValidatedSubjectUpdate(true);
  };

  const handleAddSubject = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidatedSubject(true);
      return;
    }

    if (!hasSearched || sectionIdNum <= 0 || examIdNum <= 0) {
      toast.warning("Search for a section and exam before adding subjects.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (!validateMarks(Total_Marks, Pass_Marks)) {
      toast.error("Total marks must be greater than or equal to pass marks.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (!addEmployeeId) {
      toast.warning("Please select a teacher.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setLoadingSubjectButton(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      MemberType: MemberType,
      SectionID: sectionIdNum,
      Subject_ID: parseInt(Subject_ID, 10),
      Teacher_ID: addEmployeeId,
      Exam_ID: examIdNum,
      Total_Marks: parseInt(Total_Marks, 10),
      Pass_Marks: parseInt(Pass_Marks, 10),
    };

    axios({
      method: "post",
      url: config.base_url + "Sections/AddSectionSubject",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          resetAddForm();
          bumpList();
        } else {
          toast.error(
            response.data.status_message || "Unable to add subject.",
            { position: toast.POSITION.TOP_RIGHT }
          );
        }
        setLoadingSubjectButton(false);
      })
      .catch(function () {
        setLoadingSubjectButton(false);
        toast.error("Network error. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });

    setValidatedSubject(true);
  };

  const deleteSubject = (ID) => {
    const confirmed = window.confirm("Are you sure you want to delete?");
    if (!confirmed) return;

    axios({
      method: "post",
      url: config.base_url + "Sections/DeleteSectionSubject",
      headers: { "Content-Type": "application/json" },
      data: {
        UserID: UserID,
        AccessKey: AccessKey,
        MemberType: MemberType,
        ID: ID,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          bumpList();
        } else {
          toast.error(
            response.data.status_message || "Unable to delete subject.",
            { position: toast.POSITION.TOP_RIGHT }
          );
        }
      })
      .catch(function () {
        toast.error("Network error. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const sumMarks = (field) =>
    subjects.reduce((sum, item) => sum + (Number(item[field]) || 0), 0);

  const editTeacherValue =
    dropdownOptions.find((o) => o.value === editEmployeeId) || null;
  const addTeacherValue =
    dropdownOptions.find((o) => o.value === addEmployeeId) || null;

  const renderSubjects = () => {
    if (subjects.length > 0) {
      return subjects.map((item, index) => (
        <tr key={item.ID || index}>
          <td>{item.SubjectName}</td>
          <td>{item.Total_Marks}</td>
          <td>{item.Pass_Marks}</td>
          <td>{item.Name}</td>
          <td>
            <ul
              className="inline-action"
              aria-labelledby="dropdownMenuButton1"
            >
              <li>
                <button
                  type="button"
                  className="green"
                  onClick={() => handleShow(item)}
                >
                  <i className="ri-edit-line"></i>
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => deleteSubject(item.ID)}
                  className="red"
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              </li>
            </ul>
          </td>
        </tr>
      ));
    }

    if (hasSearched && !loadingSubjects) {
      return (
        <tr>
          <td colSpan={5}>
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No subjects found for this section and exam.
            </h4>
          </td>
        </tr>
      );
    }

    if (!hasSearched && !loadingSubjects) {
      return (
        <tr>
          <td colSpan={5}>
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              Select filters and click Search to load subjects.
            </h4>
          </td>
        </tr>
      );
    }

    return null;
  };

  return (
    <>
      <ToastContainer />
      <Examination_navbar />
      <Modal className="theme-modal" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Section Subject</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={validatedSubjectUpdate}
            onSubmit={handleUpdateSubject}
          >
            <div style={{ padding: "20px" }}>
              <div className="form-group mb-3">
                <label>Select Subject</label>
                <select
                  className="form-select"
                  name="Subject_ID"
                  value={editSubjectId}
                  onChange={(e) => setEditSubjectId(e.target.value)}
                  required
                >
                  <option value="">Please Select</option>
                  <SubjectDropDown />
                </select>
              </div>
              <div className="form-group mb-3">
                <label>Teacher Name</label>
                <Select
                  {...teacherSelectCommonProps}
                  onChange={(opt) =>
                    setEditEmployeeId(opt ? opt.value : null)
                  }
                  options={dropdownOptions}
                  value={editTeacherValue}
                />
              </div>
              <div className="form-group mb-3">
                <label>Total Marks</label>
                <input
                  type="number"
                  min="0"
                  value={editTotalMarks}
                  onChange={(e) => setEditTotalMarks(e.target.value)}
                  name="Total_Marks"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label>Pass Marks</label>
                <input
                  type="number"
                  min="0"
                  value={editPassMarks}
                  onChange={(e) => setEditPassMarks(e.target.value)}
                  name="Pass_Marks"
                  className="form-control"
                  required
                />
              </div>
              {loadingUpdatesubjectButton ? (
                <div className="text-center">
                  <Spinner animation="border" role="status"></Spinner>
                </div>
              ) : (
                <button
                  type="submit"
                  className="button button-primary w-100"
                >
                  UPDATE
                </button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/Dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/ExaminationSystem/ExaminationDashboard">
                        Examinations
                      </Link>
                    </li>
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      Manage Section Level Subjects
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Manage Section Level Subjects</div>
              </div>
              <div className="col-md-6">
                <div className="page-right-actions">
                  <button
                    onClick={() => setShowFilters((prev) => !prev)}
                    className="button button-white button-icon"
                    type="button"
                  >
                    {showFilters ? "Hide Filters" : "Show Filters"}
                    <i className="ri-filter-3-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`collapse ${showFilters ? "show" : ""}`}
          id="collapseFilteres"
        >
          <Form noValidate validated={validatedSection} onSubmit={handleSubmit}>
            <div className="page-content">
              <div className="container">
                <div className="card mb-2">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label>Select Session:</label>
                          <select
                            className="form-select"
                            required
                            value={SessionId}
                            onChange={(e) => {
                              setSessionId(e.target.value);
                              setWingId("0");
                              setClassId("");
                              setSectionID("0");
                              setExamID("");
                              setHasSearched(false);
                            }}
                            name="SessionID"
                          >
                            <option value="0">---All---</option>
                            <SessionsDropDown selectedSession={SessionId} />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label>Select Wing:</label>
                          <select
                            name="WingId"
                            required
                            value={WingId}
                            onChange={(e) => {
                              setWingId(e.target.value);
                              setClassId("");
                              setSectionID("0");
                              setExamID("");
                              setHasSearched(false);
                            }}
                            className="form-select"
                          >
                            <option value="0">---All---</option>
                            <WingsDropDown />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label>Select Class:</label>
                          <select
                            className="form-select"
                            required
                            value={ClassId}
                            onChange={(e) => {
                              setClassId(e.target.value);
                              setSectionID("0");
                              setExamID("");
                              setHasSearched(false);
                            }}
                            name="Class_ID"
                          >
                            <option value="">Please Select</option>
                            {SessionId !== "0" &&
                              WingId !== "0" && (
                                <ClassesDropDown
                                  SessionID={SessionId}
                                  WingID={WingId}
                                />
                              )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label>Select Section:</label>
                          <select
                            className="form-select"
                            required
                            value={SectionID}
                            onChange={(e) => {
                              setSectionID(e.target.value);
                              setExamID("");
                              setHasSearched(false);
                            }}
                            name="Section_Id"
                          >
                            <option value="0">Please Select</option>
                            {ClassId !== "" && ClassId !== "0" && (
                              <SectionDropDown ClassID={ClassId} />
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label>Select Examination:</label>
                          <select
                            className="form-select"
                            required
                            value={ExamID}
                            onChange={(e) => {
                              setExamID(e.target.value);
                              setHasSearched(false);
                            }}
                            name="ExamID"
                          >
                            <option value="">Please Select</option>
                            <ExamsDropDown SessionID={examSessionId} />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2 offset-md-7">
                        <div className="form-group mt-md-4">
                          <button
                            type="submit"
                            className="button button-primary w-100"
                            disabled={loadingSubjects}
                          >
                            {loadingSubjects ? "Searching..." : "Search"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <Form
                  noValidate
                  validated={validatedSubject}
                  onSubmit={handleAddSubject}
                >
                  <table className="table table-theme">
                    <thead>
                      <tr>
                        <th style={{ width: "250px" }}>Subject</th>
                        <th style={{ width: "150px" }}>Total Marks</th>
                        <th style={{ width: "150px" }}>Pass Marks</th>
                        <th>Teacher Name</th>
                        <th className="text-center text-nowrap">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <select
                            className="form-select"
                            name="Subject_ID"
                            value={Subject_ID}
                            onChange={(e) => setSubject_ID(e.target.value)}
                            required
                            disabled={!hasSearched}
                          >
                            <option value="">Please Select</option>
                            <SubjectDropDown />
                          </select>
                        </td>
                        <td>
                          <input
                            type="number"
                            min="0"
                            onChange={(e) => setTotal_Marks(e.target.value)}
                            value={Total_Marks}
                            name="Total_Marks"
                            className="form-control"
                            required
                            disabled={!hasSearched}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            min="0"
                            onChange={(e) => setPass_Marks(e.target.value)}
                            value={Pass_Marks}
                            name="Pass_Marks"
                            className="form-control"
                            required
                            disabled={!hasSearched}
                          />
                        </td>
                        <td>
                          <Select
                            {...teacherSelectCommonProps}
                            isDisabled={!hasSearched}
                            onChange={(opt) =>
                              setAddEmployeeId(opt ? opt.value : null)
                            }
                            options={dropdownOptions}
                            value={addTeacherValue}
                          />
                        </td>
                        <td className="text-end">
                          <ul
                            className="inline-action"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              {loadingsubjectButton ? (
                                <Spinner
                                  animation="grow"
                                  size="sm"
                                  variant="danger"
                                />
                              ) : (
                                <button
                                  type="submit"
                                  className="blue"
                                  disabled={!hasSearched}
                                >
                                  <i className="ri-add-fill fs-4"></i>
                                </button>
                              )}
                            </li>
                          </ul>
                        </td>
                      </tr>
                      {loadingSubjects ? (
                        <tr>
                          <td colSpan={5} className="text-center">
                            <Spinner animation="border" role="status" />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {renderSubjects()}
                          {hasSearched && subjects.length > 0 && (
                            <tr>
                              <th className="text-end">Total:</th>
                              <th>{sumMarks("Total_Marks")}</th>
                              <th>{sumMarks("Pass_Marks")}</th>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </>
                      )}
                    </tbody>
                  </table>

                  {totalRecords > pageSize && (
                    <div className="pagination-wrap mt-3">
                      <div className="row align-items-center">
                        <div className="col-md-2 form_default">
                          <div className="d-flex align-items-center">
                            <label
                              className="me-2"
                              style={{ fontSize: "15px" }}
                            >
                              Page Size
                            </label>
                            <select
                              className="form-select"
                              style={{ width: "100px" }}
                              value={pageSize}
                              onChange={handlePageSizeChange}
                            >
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </div>
                        </div>
                        <Pagination
                          pageNo={pageNo}
                          pageSize={pageSize}
                          totalRecords={totalRecords}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageClassSubjects;
